import { buildPolicyHook } from 'policy-lib';
import { EnrichmentPolicy } from './EnrichmentPolicy';
import { useEnrichmentSettings } from '../EnrichmentSettingsProvider';
const useBaseEnrichmentPolicy = buildPolicyHook(EnrichmentPolicy);

/**
 * Get access to the enrichment policy tied to the current user.
 *
 * @deprecated use `useEnrichmentPolicyNext` instead
 */
export function useEnrichmentPolicy() {
  const {
    settings,
    isLoaded
  } = useEnrichmentSettings();
  return useBaseEnrichmentPolicy({
    settings,
    isLoaded
  });
}